import React from "react";

export const Button = (props) => {
  return (
    <div>
      <a 
        className="inline-block bg-emerald-600 px-10 py-4 rounded-full text-center text-base text-white font-bold hover:scale-110 hover:bg-emerald-500 active:ring-offset-2 active:ring-2 active:bg-emerald-600 ease-in-out duration-300 transition drop-shadow-xl cursor-pointer"
        href={props.link} target="_blank" rel="noreferrer" 
      >
        {props.name}
      </a>
    </div>
  );
};

export default Button;
